var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 529,
    height: 457,
    viewBox: "0 0 529 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2534_9058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.98 13.1801C133.55 13.1801 34.3101 112.43 34.3101 234.85C34.3101 292.33 56.1901 344.7 92.0801 384.09L405.22 70.9501C365.83 35.07 313.46 13.1801 255.98 13.1801Z",
    fill: "#E0E4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.84 85.62L105.7 398.76C145.09 434.64 197.46 456.53 254.94 456.53C377.37 456.53 476.61 357.28 476.61 234.86C476.61 177.38 454.73 125.01 418.84 85.62Z",
    fill: "#F3F0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.74 193.83C418.74 193.83 403.15 195.53 396.25 192.77C389.35 190.01 383.41 186.08 380.9 181.21C378.4 176.34 377.08 171.19 377.08 171.19L376.69 166.95L375.45 146.05L375.15 125.77C375.15 125.77 375.25 111.53 377.36 108.02C379.47 104.51 384.71 97.18 386.65 95.87C388.59 94.56 397.76 87.9 397.76 87.9C397.76 87.9 397.47 91.7 398.5 93.26C399.53 94.82 401.94 100.61 405.72 103.27C409.5 105.94 415.16 109.12 420.03 109.12C424.9 109.12 434.83 107.97 434.83 107.97L455.09 106.71L455.95 116.15L474.13 124.42L481.94 140.12L474.37 156.76L444.52 199.2L446.09 214.96L447.01 218.24C447.01 218.24 449.44 232.1 440.66 235.72C431.88 239.34 424.84 237.81 422.77 235.39C420.7 232.97 419.35 229.68 419.52 227.75C419.69 225.82 420.5 222.59 420.5 222.59L421.4 219.73L418.75 193.83L418.73 193.85L418.74 193.83Z",
    fill: "#F2F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.93 220.54C419.05 222.51 420.09 227.3 423.65 228.47C427.21 229.64 430.12 229.94 430.12 229.94L433.85 229.73L437.52 228.92L439.93 227.91L442.3 226.24L445.99 221.75L439.74 235.57C439.74 235.57 432.65 248.87 432.34 249.61C432.03 250.35 429.59 270.31 429.59 270.31C429.59 270.31 416.37 263.96 417.45 252.1C418.53 240.24 418.91 233.05 419.59 227.52L418.91 220.54",
    fill: "#7B57F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.17 124.77C375.16 125.4 375.16 125.77 375.16 125.77L375.46 146.05L376.7 166.95L377.09 171.2C377.09 171.2 378.41 176.35 380.91 181.22C383.41 186.09 389.35 190.01 396.26 192.78C403.16 195.54 418.75 193.84 418.75 193.84L418.77 193.82L420.53 211.06L420.68 210.08L437.37 187.5C428.16 190.13 425.21 190.59 421.72 190.76C415.56 191.07 409.36 190.3 403.79 188.07C396.89 185.31 390.95 180.31 388.44 175.44C383.68 166.18 377.22 144.71 375.17 124.77Z",
    fill: "#232637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.13 129.25L369.69 124.98C369.69 124.98 361.61 116.61 360.4 109.92C359.19 103.22 357.97 93.2801 363.22 83.9101C368.47 74.5301 378.51 69.51 378.51 69.51C378.51 69.51 388.33 67.1 390.09 67.33C391.86 67.56 399.89 68.85 401.54 69.43C403.19 70.02 409.55 73.25 409.55 73.25L413.93 76.92C413.93 76.92 422.06 71.35 425.08 70.65C428.1 69.94 437.57 68.02 446.68 69.92C455.78 71.81 469.23 76.14 472.77 79.03C476.31 81.91 489.17 91.14 490.79 103.31C492.41 115.48 492.74 120.61 492.74 120.61C492.74 120.61 491.52 135.28 499.66 143.41C507.8 151.54 509.12 159.08 509.12 159.08C509.12 159.08 509.9 171.42 505.64 176.11C501.38 180.79 492.93 188.98 482.71 193.06C472.5 197.14 457.09 201.16 457.09 201.16L452.33 202.03L444.67 203.31L442.95 184.41C442.95 184.41 445.76 184.03 448.42 181.88C451.08 179.73 455.38 174.27 455.93 172.79C456.48 171.31 457.22 168.24 457.22 168.24L457.51 164.03L457.42 160.83C457.42 160.83 463.83 159.05 468.13 154.79C472.43 150.54 475.55 146.46 475.55 146.46L476.96 143.52C476.96 143.52 477.91 137.12 477.5 135.99C477.08 134.86 474.74 129.61 473.44 128.53C472.14 127.45 469.53 125.55 467.85 125.44C466.17 125.33 463.51 125.57 462.89 125.74C462.26 125.91 458.74 127.48 458.74 127.48L454.79 130.81C454.18 131.32 453.25 130.94 453.18 130.15L451.15 107.76C451.15 107.76 443.1 109.89 436.19 110.03C429.29 110.17 418.88 111.52 410.81 106.78C402.74 102.04 400.13 97.76 399.41 95.9C398.69 94.04 397.78 88.47 397.78 88.47C397.78 88.47 387.09 93.7601 381.86 101.69C376.63 109.62 374.8 119.24 374.8 119.24L375.1 124.78L375.08 129.24L375.11 129.28L375.13 129.25Z",
    fill: "#232637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.61 257.31C432.32 251.69 435.59 242.46 436.75 240.75C437.91 239.04 445.82 224.71 446.31 220.34C446.8 215.97 446.28 210.41 446.28 210.41L445.36 207.13L443.97 199.46L443.88 198.42C443.88 198.42 446.64 198.02 447.93 198.15C449.22 198.28 451.64 198.9 452.43 199.5C453.21 200.1 455.14 201.32 455.3 203.03C455.46 204.74 456.73 208.19 456.73 208.19L457.9 213.5C457.9 213.5 468.83 214.81 471.61 215.76C474.38 216.71 485.36 218.66 490.9 221.73C496.43 224.8 505.92 232.68 509.43 237.69C511.74 240.98 518.62 248.31 522.62 261.31C529.33 283.13 527.62 294.31 527.62 294.31C527.62 294.31 527.38 335.84 526.75 342.12C526.47 344.89 526.91 352.45 524.62 356.31C522.33 360.17 517.31 360.34 513.62 361.31C494.62 366.31 453.62 362.31 453.62 362.31L429.62 270.31L430.62 257.31H430.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.63 184.44C443.63 184.44 459.75 179.09 457.32 160.89C463.62 158.56 465.4 157.77 471.52 151.56C477.63 145.35 479.5 139.34 475.9 131.54C474.82 129.21 470.88 125.81 467.91 125.44C464.06 124.95 460.19 126.18 457.17 128.63L454.81 130.54C454.2 131.03 453.29 130.65 453.22 129.87L451.22 107.77C451.22 107.77 446.02 110.57 424.98 110.15C396.76 107.78 397.85 88.49 397.85 88.49C397.85 88.49 375.75 99.32 375.26 119.59C374.77 139.86 376.14 169.31 377.97 175.11C379.79 180.91 387.58 196.93 412.08 194.89",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.85 127.77C367.16 123.29 353.41 109.66 361.72 87.43C372.03 59.8 403.57 65.57 413.95 76.93C421.27 70.77 426.23 70.05 434.1 69.08C437.37 68.67 488.79 69.09 492.08 111.18C493.92 131.42 491.65 135.29 500.87 144.66C510.09 154.03 522.66 177.22 475.72 196.13C466.82 199.05 459.81 200.7 454.79 201.62",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.61 272.31C428.61 250.31 436.06 242.83 443.07 229.45C450.08 216.09 445.1 206.5 445.1 206.5L443.02 184.62",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.61 213.31C459.61 213.31 481.83 215.63 498.71 227.12C509.75 234.63 514.12 242.2 517.47 247.76C529.08 267 530.32 317.16 524.71 356.43C523.68 363.67 480.21 365.74 449.16 361.6",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.61 198.31C444.61 198.31 451.61 196.31 455.61 204.31C459.39 211.87 462.61 222.31 463.36 232.13C458.61 231.31 453.61 231.31 453.61 231.31L457.45 240.59C457.45 240.59 438.61 251.31 435.61 291.31",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.79 215.99C446.79 215.99 446.79 226.36 437.07 229.06C426.35 232.03 414.5 227.67 420.58 214.42",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.03 140.82C408.03 140.82 403.37 146.67 400.57 149.88C399.88 150.67 399.89 151.87 400.71 152.53C402.99 154.36 407.77 157.48 413.32 156.68",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.41 276.32C450.58 276.67 447.13 273.07 446.7 268.27C446.27 263.48 449.01 259.31 452.84 258.97C456.67 258.63 460.12 262.23 460.55 267.02C460.98 271.81 458.24 275.98 454.41 276.32Z",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.29 266.08C444.18 266.85 444.16 267.67 444.24 268.49C444.67 273.28 448.13 276.88 451.95 276.54L454.4 276.32",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.79 208.56C483.05 221.22 452.84 258.97 452.84 258.97L450.39 259.19C448.02 259.41 446.05 261.09 445.02 263.48",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.09 272.82C451.81 273.03 449.74 270.88 449.48 268.02C449.22 265.16 450.86 262.67 453.15 262.47C455.43 262.26 457.5 264.41 457.76 267.27C458.02 270.13 456.38 272.62 454.09 272.82Z",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.4 113.23C420.4 113.23 429.06 111.49 432.87 115.93",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.46 115.39C394.46 115.39 386.59 113.22 382.92 118.03",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.43 134.74C461.6 127.53 475.89 131.61 470.78 142.84",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.71 157.21C417.87 158.48 409.51 151.14 408.03 140.82C406.55 130.5 412.51 121.1 421.34 119.83C430.18 118.56 438.54 125.9 440.02 136.22C441.5 146.54 435.54 155.94 426.71 157.21Z",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.68 148.58C402.07 146.4 402.12 144.08 401.78 141.73C400.3 131.41 391.93 124.07 383.1 125.34C374.26 126.61 368.31 136.01 369.79 146.33C371.27 156.65 379.64 163.99 388.47 162.72C393.99 161.93 398.39 157.96 400.55 152.58",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.47 135.64L454.61 130.66",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.51 145.79C391.64 145.91 390.73 144.52 390.46 142.68C390.19 140.84 390.68 139.24 391.55 139.12C392.42 139 393.33 140.39 393.6 142.23C393.87 144.07 393.38 145.67 392.51 145.79Z",
    fill: "#232837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.51 143.79C420.64 143.91 419.73 142.52 419.46 140.68C419.19 138.84 419.68 137.24 420.55 137.12C421.42 137 422.33 138.39 422.6 140.23C422.87 142.07 422.38 143.67 421.51 143.79Z",
    fill: "#232837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.34 163.78C428.34 163.78 422.48 164.31 411.83 166.26C411.83 166.26 417.47 173.02 421.24 172.3C429.46 170.72 428.34 163.78 428.34 163.78Z",
    fill: "#232837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.14 281.91C478.14 281.91 480.6 306.31 480.21 321.24C469.6 321.31 449.6 319.31 435.6 319.31",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.9 215.38C390.83 209.61 391.64 198.72 391.65 194.76C391.65 190.41 384.12 181.42 387.51 177.85C390.04 175.19 394.84 176.93 396.82 180.15C400.1 185.48 401.34 189.43 404.28 190.82C408.2 192.67 421.13 186.7 427.27 183.84C433.41 180.98 436.77 179.89 438.85 179.69C441.89 179.39 448.51 185.37 434.96 191.92C436.86 193.22 438.33 195.05 438.24 197.62C438.2 198.78 436.71 200.45 432.39 202.99C433.46 205.39 433.37 205.92 432.88 208.35C431.73 214.13 420.84 217.99 416.39 221.15L410.96 250.18L393.94 247.76L382.91 242.59L392.88 215.38H392.9Z",
    fill: "#F2F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.67 192.46C435.73 192.88 438.62 194.53 437.99 197.62C437.54 199.83 435.92 202.57 425.39 206.88",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.41 204.01C433.52 205.43 433.32 206.42 432.61 208.34C430.56 213.87 420.54 217.94 416.09 221.09L410.58 250.11",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.29 195.15C450.57 187.54 442.18 179.36 438.64 179.7C436.56 179.9 433.19 180.98 427.04 183.82C420.89 186.66 407.89 192.62 403.98 190.76C401.05 189.36 399.88 185.4 396.61 180.06C394.64 176.84 389.84 175.09 387.31 177.74C383.91 181.3 391.42 190.31 391.4 194.66C391.39 198.62 390.55 209.51 392.6 215.28L382.94 242.59",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.63 328.33C408.18 303.73 420.26 252.16 420.18 228.05C404.35 228.86 395.03 227.94 379.45 230.8C378.69 230.94 377.88 231.11 377.35 231.66C376.67 232.36 376.67 233.44 376.71 234.41C377.99 264.14 344.79 305.72 370.4 330.75",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.63 328.33C408.18 303.73 420.26 252.16 420.18 228.05C404.35 228.86 395.03 227.94 379.45 230.8C378.69 230.94 377.88 231.11 377.35 231.66C376.67 232.36 376.67 233.44 376.71 234.41C377.99 264.14 344.79 305.72 370.4 330.75",
    stroke: "#232637",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.47 194.46C391.47 194.46 390.72 201.17 390.81 203.31C390.93 206.39 392.95 214.97 392.95 214.97L387.07 230.16C387.07 230.16 401.56 228.09 414.95 228.4L416.48 220.85C416.48 220.85 410.07 219.62 403.64 217.75C390.91 214.06 391.49 194.46 391.49 194.46H391.47Z",
    fill: "#232637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.57 261.45L450.16 379.72H352.37H320.12H265.79C262.87 379.72 260.31 377.74 259.58 374.91L229.61 259.04H416.47C417.93 259.04 419.21 260.03 419.57 261.44V261.45Z",
    fill: "#E6E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.68 379.36L322.17 346.5L298.64 379.36H320.68Z",
    fill: "#DADEE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.59 257.1L440.88 312.88L455.5 369.94C456.06 372.14 455.42 374.46 453.82 376.07L450.16 379.73L418.95 259.05H229.61L234.49 254.17C235.69 252.97 237.32 252.29 239.02 252.29H420.37C423.3 252.29 425.86 254.27 426.58 257.11L426.59 257.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.33 376.56L419.56 261.44C419.19 260.03 417.92 259.04 416.46 259.04H233.77",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43 256.59L455.49 369.93C456.05 372.13 455.41 374.46 453.81 376.06L452.03 377.84C450.83 379.04 449.2 379.72 447.49 379.72H265.78C262.86 379.72 260.3 377.74 259.57 374.91L230.52 262.59C229.95 260.39 230.59 258.06 232.19 256.45L234.49 254.15C235.69 252.95 237.31 252.28 239.01 252.27L420.19 251.77C423.13 251.77 425.69 253.75 426.42 256.59H426.43Z",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.4 409.16C307 410.97 308.38 412.67 310.23 412.67H337.84L363.56 413.01V410.48C363.56 408.08 361.61 406.14 359.22 406.14H339.28L351.48 350.33C351.92 348.33 350.39 346.44 348.35 346.44H323.71C322.2 346.44 320.9 347.49 320.58 348.96L307.42 409.17L307.4 409.16Z",
    fill: "#DADEE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.65 408.81C307.17 411.06 308.89 413.18 311.19 413.18H326.75C327.74 413.18 328.61 412.51 328.86 411.54L342.78 356.54C343.24 354.71 341.86 352.93 339.97 352.93H323.05C321 352.93 319.23 354.36 318.8 356.37L307.65 408.8V408.81Z",
    fill: "#E6E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.91 406.3H359.82C361.82 406.3 363.44 407.92 363.44 409.92V412.28C363.44 412.68 363.12 413 362.72 413H337.84H311.12C308.81 413 307.09 410.87 307.58 408.61L320.49 349.27C320.85 347.61 322.32 346.42 324.03 346.42H347.78C350.11 346.42 351.83 348.58 351.31 350.85L337.84 409.55",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7 150.35L117.16 149.28C117.16 149.28 110.75 158.89 93.6 158.57C83.74 158.38 77.57 149.84 77.57 149.84L77.83 146.15L77.79 141.05L15.92 171.96C15.92 171.96 11.12 177.82 8.12004 184.82C3.36004 195.93 1.79004 215.12 1.79004 215.12L1.29004 222.9L17.31 221.84C17.31 221.84 41.43 273.44 36.6 277.45C12.11 297.82 21.11 325.82 21.11 325.82L91.61 384.32L142.61 334.32C142.61 320.32 146.89 301.99 135.11 278.82C128.83 266.47 121.11 265.82 121.11 262.82C121.11 254.76 123.54 253.6 127.11 250.82C136.11 243.82 141.11 236.82 145.11 216.82L170.5 212.77L169.67 207.97C169.67 207.97 166.42 197.27 165.81 191.24C165.21 185.21 161.67 175.87 157 165.6C154.95 161.09 147.92 154.88 143.66 153.32L125.69 150.34L125.7 150.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.26 154.93C82.84 153.3 77.64 150.35 77.64 150.35L44.53 135.4C44.53 135.4 66.08 98.2001 62.35 90.3401C58.62 82.4901 55.77 74.6901 57.15 70.9901C58.53 67.2901 59.83 64.1701 63.63 63.0301C67.43 61.8901 73.05 62.2601 73.05 62.2601L79.08 66.1301L83.51 55.5701L87.26 45.9801C87.26 45.9801 113.04 44.6301 124.45 38.9701C135.86 33.3001 141.76 28.8301 141.76 28.8301L145.14 23.8101C145.14 23.8101 148.6 27.1601 149.83 30.3701C151.06 33.5801 155.44 46.7601 155.44 46.7601L156.43 59.1801L155.7 73.3401C155.7 73.3401 154.06 87.3001 154.01 92.8201C153.96 98.3501 149.19 108.53 147.07 111.89C144.95 115.24 142.8 118.3 142.8 118.3L139.6 121.5L132.53 124.64C122.54 124.73 120.32 125.52 111.69 122.81L108.63 147.14L117.17 149.28C117.17 149.28 112.11 155.99 103.29 157.82C98.81 158.75 89.07 157.48 85.28 154.93H85.26Z",
    fill: "#F0F3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.77 74.5099C78.7 65.9699 59.48 60.6299 65.89 81.9899",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.85 117.24C143.85 117.24 139.58 124.72 123.89 125.17C121.02 125.25 115.48 123.14 112.61 122.94C107.54 122.58 98.27 118.21 98.27 118.21L80.84 150.35L81.03 109.34L81.21 109.43C79.94 108.71 78.61 107.94 77.26 107.13C69.62 102.55 61.46 88.86 58.34 82.59L56.97 75.89L57.47 68.11L63.46 62.9C62.46 67.68 59.48 89.47 74.43 89.47C76.44 89.47 78.49 89.76 80.55 90.3C88.54 92.36 89.04 101.45 96.86 107.63C108.25 116.63 123.56 122.58 143.85 117.24Z",
    fill: "#232837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.24 150.35C138.36 144.59 136.83 129.78 135.52 123.78C124.99 126.55 117.68 124.21 112.09 122.9L109.31 139.96C119.2 140.4 119.4 144.6 117.15 149.28L134.24 150.35Z",
    fill: "#3B54F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.17 98.16C152.17 98.16 156.41 79.72 156.52 60.78C158.23 37.51 143.41 23.91 143.41 23.91C143.41 23.91 142.5 43.81 94.74 46.09C91.71 54.96 87.24 72.39 87.24 72.39C80.83 56.37 63.74 56.37 58.08 67.68C54.95 73.97 59.47 102.3 77.63 93.75C80.35 100.1 82 110.82 82 110.82C82 110.82 82.97 124.73 81.91 136.47C81.02 146.28 80.49 166.14 73.46 178.2C70.39 183.46 59.44 189.54 53.47 184.25C46.3 177.9 44.95 187.67 30.97 180.76C25.45 178.03 5.24 169.55 6.66 136.85C7.11 126.48 11.18 118.78 16.54 113.11C34.28 94.31 38.88 99.41 41.32 79.87C42.39 71.33 33.98 57.27 33.22 53.83C26.37 35.01 37.58 11.52 70.59 3.84001C103.27 -1.29999 132.47 -0.749993 140.94 11.34C153.52 10.58 171.79 32.26 172.64 54.98C173.37 74.24 160.49 91.99 156.62 94.71",
    fill: "#3B54F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.43 115.98C92.43 115.98 112.23 127.09 130.41 124.77C155.75 121.53 155.18 78.93 156.52 60.78C158.23 37.51 143.41 23.91 143.41 23.91C143.41 23.91 142.5 43.81 94.74 46.09C91.71 54.96 87.24 72.39 87.24 72.39C80.83 57.44 63.74 57.44 58.08 67.68C54.95 73.97 60.54 102.3 77.63 93.75C80.35 100.1 81.72 106.42 82 110.82C83.06 127.77 80.48 166.15 73.45 178.2C70.38 183.46 59.43 189.54 53.46 184.25C46.29 177.9 44.94 187.67 30.96 180.76C25.44 178.03 5.22999 169.55 6.64999 136.85C7.09999 126.48 11.17 118.78 16.53 113.11C29.47 99.4 42.6 95.85 41.31 74.53C40.93 68.13 35.97 61.71 33.21 53.83C26.36 34.28 37.57 11.52 70.58 3.84001C97.91 -1.29999 132.46 -0.749993 140.93 11.34C153.51 10.58 171.78 32.26 172.63 54.98C173.36 74.24 160.48 91.99 156.61 94.71",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.07 77.29C141.07 77.29 145.32 88.27 143.46 89.64C140.39 91.89 135.49 89.97 134.93 87.88",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45 102.28C137.45 102.28 131.04 103.35 121.07 103.8",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 124.12L108.41 146.75C108.32 147.28 108.68 147.78 109.22 147.87L117.17 149.11",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.7 126.44C135.7 126.44 139.62 138.51 134.93 149.49",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.77 150.35C79.77 150.35 89 162.72 107.05 156.79C112.64 154.95 117.2 149.12 117.2 149.12C117.2 149.12 121.17 141.74 111.75 140.53",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.34 54.6499C150.64 53.8899 151.99 59.6599 157.98 60.5999",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.15 54.65C124.85 53.89 121.43 60.63 112.17 60.6",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.71 70.4C154.63 72.97 147.06 73.44 144.67 71.06",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.16 71.45C126.77 74.51 116.53 75.83 111.23 73.39",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.19 161.46C154.19 161.46 150.36 157.12 144.84 154.24C135.18 149.21 117.2 149.11 117.2 149.11",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87 244.74L181.24 210.16L156.11 205.81L142.11 228.81L167.87 244.74Z",
    fill: "#F0F3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91 213.96L189.78 167.1C191.89 162.67 189.46 158.49 184.38 157.74L157.03 153.42C152 152.57 146.13 155.51 143.91 160.01L120.7 205.9",
    fill: "#3B54F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.15 159.35L181.57 163.62C186.67 164.36 189.09 168.55 186.96 172.99L163.28 221.22C160.98 225.79 154.82 229 149.54 228.36L121.16 224.61C115.94 223.86 113.68 219.48 116.08 214.86L140.96 165.98C143.2 161.47 149.1 158.51 154.14 159.35H154.15Z",
    fill: "#3B54F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.97 165.98L116.09 214.86C113.68 219.49 115.95 223.86 121.17 224.61L149.55 228.36C154.83 229 160.99 225.79 163.29 221.22L186.97 172.99",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.02 160.92C148.51 159.54 151.45 158.9 154.15 159.35L181.57 163.62C184.3 164.02 186.26 165.4 187.17 167.28",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91 213.96L189.78 167.1C191.89 162.67 189.46 158.49 184.38 157.74L157.03 153.42C152 152.57 146.13 155.51 143.91 160.01L120.7 205.9",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.11 209.81C165.7 207.67 159.16 201.6 158.12 200.23C155.98 197.4 158.9 193.65 161.06 194.01C161.29 194.14 161.89 194.43 162.65 194.8C162.33 194.61 162 194.42 161.63 194.2C161.45 194.09 161.26 194.04 161.06 194.01C157.95 192.28 156.05 190.85 156.45 188.7C157.25 184.45 162.06 185.45 165.15 186.77C165.15 186.77 164.85 183.35 168.71 183.12C168.71 183.12 178.48 183.98 187.46 188.78C190.45 190.38 192.01 191.14 194.57 194.17C196.94 196.98 190.75 210.36 187.04 214C185.26 215.74 181.83 217.85 180.1 218.82C183.1 224.82 199.89 253.77 189.27 267.17C172.1 288.82 139.14 265.77 137.1 239.82L142.1 228.82L159.1 231.82L172.1 209.82L172.11 209.81Z",
    fill: "#F0F3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.09 223.56C174.65 219.9 181.15 219.79 187.05 214C190.76 210.36 196.95 196.98 194.58 194.17C192.02 191.14 190.47 190.38 187.47 188.78C178.49 183.99 168.72 183.12 168.72 183.12C164.86 183.35 165.16 186.77 165.16 186.77",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.99 194.86L165.16 186.77C162.07 185.45 157.25 184.45 156.46 188.7C155.73 192.62 162.6 194.15 170.67 199.47",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.22 211.68C166.31 207.49 160.22 203.01 158.12 200.23C155.78 197.15 159.48 192.95 161.63 194.2C170.67 199.47 166.69 197.77 179.65 203.78",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.11 240.81C138.85 263.21 172.11 289.81 189.28 267.16C200.57 252.27 180.11 218.81 180.11 218.81",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.81 327.64C147.08 287.05 131.05 270.13 125.11 266.81C121.21 264.63 120.85 259.68 121.11 258.81C124.11 248.81 136.11 250.81 142.11 227.81",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5699 325.51C21.5699 325.51 17.38 310.54 22.42 297.12",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.61 77.3101C128.61 77.3101 128.21 89.4701 120.66 89.6401C113.11 89.8101 109.32 84.9901 109.32 84.9901C109.32 84.9901 116.27 84.7901 120.61 82.3101C127.61 78.3101 128.61 77.3101 128.61 77.3101Z",
    fill: "#232837"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.61 81.3101C148.61 80.3101 145.61 76.3101 145.61 76.3101C145.61 76.3101 146.27 88.4701 153.82 88.6401L154.61 81.3101Z",
    fill: "#232837"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.11 231.81C141.11 231.81 148.11 254.81 164.11 263.81C168.47 266.26 183.45 274.5 189.28 267.16C189.28 267.16 180.05 285.14 159.11 271.81C137.11 257.81 137.11 239.81 137.11 239.81L141.11 231.81Z",
    fill: "#232837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.11 244.81C154.11 244.81 151.11 239.81 149.11 228.81",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M52.61 273.31C52.61 273.31 60.79 246.33 80.57 238.01C100.55 229.61 118.85 236.17 122.71 244.05C129.31 257.5 107 265.8 107 265.8L52.61 273.31Z",
    fill: "#232837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.11 265.81H135.1C135.65 265.46 136.11 265.12 136.44 264.81C139.67 261.81 137.52 255.81 129.98 258.81L129.9 258.88C130.23 257.37 130.22 256.25 129.98 255.81C126.93 250.15 100.08 261.54 98.74 257.81C97.66 254.81 98.74 243.81 91.2 243.81C86.89 243.81 85.81 249.65 85.81 252.81C85.81 259.81 83.73 261.54 73.96 261.81C66.63 262.02 57.43 261.87 46.34 261.23L43.11 260.81L49.11 222.81L30.11 221.81L7.17003 223.81C6.78003 230.14 5.48003 273.49 7.23003 282.7C7.87003 286.05 8.89003 289.48 11.27 292.07C13.85 294.88 20.11 298.81 35.11 296.81C62.21 293.2 72.24 288.81 94.43 288.81C116.62 288.81 123.52 286.81 131.06 282.81C138.77 278.72 138.81 275.77 136.45 273.81L135.54 273.69C137.38 272.94 138.86 272.26 139.68 271.81C145.07 268.81 141.58 261.81 135.12 265.81H135.11Z",
    fill: "#F0F3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.74 264.81C132.13 260.81 131.05 257.81 129.98 255.81C126.93 250.15 100.08 261.54 98.74 257.81C97.66 254.81 98.74 243.81 91.2 243.81C86.89 243.81 85.81 249.65 85.81 252.81C85.81 259.81 83.72 261.54 73.96 261.81C63.88 262.09 50.26 260.81 33.02 260.81",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.97 258.81C137.51 255.81 139.67 261.81 136.43 264.81C134.28 266.81 127.81 269.81 114.89 271.81",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.12 278.81C125.66 277.81 136.74 273.44 139.66 271.81C145.05 268.81 141.56 261.81 135.1 265.81",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17003 223.81C6.78003 230.14 5.48003 273.49 7.23003 282.7C7.87003 286.05 8.89003 289.48 11.27 292.07C13.85 294.88 20.11 298.81 35.11 296.81C62.21 293.2 72.24 288.81 94.43 288.81C116.62 288.81 123.52 286.81 131.06 282.81C138.6 278.81 138.81 275.77 136.45 273.81",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.11 222.81C47.43 234.18 43.11 260.81 43.11 260.81",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.11 170.81C7.11003 180.81 2.17003 205.4 2.04003 215.01C0.410028 218.68 0.690028 221.71 0.950028 223.05C1.04003 223.49 1.44003 223.76 1.88003 223.71C6.89003 223.22 31.11 221.88 38.09 221.85C46.1 221.81 51.47 222.59 53.55 222.7C53.91 222.72 54.25 222.53 54.38 222.2C54.66 221.5 53.89 220.19 54.08 216.12C54.22 212.98 56.93 208.21 59.1 200.81",
    stroke: "#232837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M59.11 286.98C37.11 288.15 26.04 286.81 20.11 282.81C15.37 279.61 17.32 237.85 17.86 222.88L7.17003 223.81C6.78003 230.14 5.48003 273.49 7.23003 282.7C7.87003 286.05 8.89003 289.48 11.27 292.07C13.85 294.88 20.11 298.81 35.11 296.81C62.21 293.2 72.24 288.81 94.43 288.81C96.11 288.81 81.11 285.81 59.11 286.98Z",
    fill: "#232837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.91 97.0001C227.27 97.9501 218.15 100.39 209.73 104.06L204.61 93.3101L191.31 114.87L175.61 140.31L196.11 138.03L238.61 133.31L223.89 121.66C225.49 121.07 227.1 120.52 228.75 120.02C268.39 107.92 309.94 124.54 331.07 157.95C318.05 119.02 279.49 92.8101 236.91 97.0001Z",
    fill: "url(#paint0_linear_2534_9058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.77 372.26C269.41 371.31 278.53 368.87 286.95 365.2L292.07 375.95L305.37 354.39L321.07 328.95L300.57 331.23L258.07 335.95L272.79 347.6C271.19 348.19 269.58 348.74 267.93 349.24C228.29 361.34 186.74 344.72 165.61 311.31C178.63 350.24 217.19 376.45 259.77 372.26Z",
    fill: "url(#paint1_linear_2534_9058)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2534_9058",
    x1: 185.91,
    y1: 102.85,
    x2: 366.51,
    y2: 184.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#788CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7884F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7A63F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7B57F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2534_9058",
    x1: 168.2,
    y1: 356.17,
    x2: 367.77,
    y2: 314.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#787FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#787BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#796FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7A5CF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7B57F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2534_9058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 528.7,
    height: 456.53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorPatient);
export default __webpack_public_path__ + "static/media/DoctorPatient.70fd0a0f8e811111c5821a4fd831048c.svg";
export { ForwardRef as ReactComponent };